import allowed from '@/core/constants/allowed-roles.constant'

const routes = [
  {
    name: 'incident-observation-analytics',
    path: '/risk-exposure',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'incident-observation-analytics',
      breadcrumb: {
        label: 'core.menu.modules.risk-exposure',
        route: 'incident-observation-analytics',
      },
    },
    children: [
      {
        name: 'incident-observation-analytics-home',
        path: '/risk-exposure/incident-observation-analytics',
        meta: {
          allowedRoles: [...allowed.incident_observation_analytics.roles],
          breadcrumb: {
            label: 'core.menu.modules.incident-observation-analytics',
            route: 'incident-observation-analytics-home',
          },
        },
        component: () =>
          import(
            '@/modules/incident-observation-analytics/pages/home/incident-observation-analytics-home.vue'
          ),
      },
    ],
  },
]

export default routes
